const maxPhoneLength = "10";
const partnerCode = "0";
const aadharLength = "12";
const pincodeLength = "6";
const allocationLength = "3";
const grossIncomeLength = "9";
const maxPincodeLength = "6";
const maxPANLength = "10";
const maxIFSCLength = "11";
const PAYMENT_URL_DEV = process.env.REACT_APP_PAYTM_URL;
const MERCHANTS_ID = process.env.REACT_APP_PAYTM_MID;
export {
  grossIncomeLength,
  maxPhoneLength,
  partnerCode,
  aadharLength,
  pincodeLength,
  PAYMENT_URL_DEV,
  MERCHANTS_ID,
  allocationLength,
  maxPincodeLength,
  maxPANLength,
  maxIFSCLength,
};
